import { presenceInput } from '@trust/trust-web-sdk-subito/dist/presence-input';
import { TrustClient, HTTPStatusCode, AidosClient } from '@sbt-web/networking';

const getUserToken = async (hadesPublicBase) => {
    const AIDOS_TIMEOUT = 1000;
    const aidosClient = new AidosClient(hadesPublicBase, AIDOS_TIMEOUT);
    try {
        const { status, token } = await aidosClient.getFeedbackUserToken();
        return status === HTTPStatusCode.OK && token ? token.value : '';
    }
    catch (error) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        console.error(`error getting user token: [${error.status}, ${error.info}]`);
        return '';
    }
};
const getSetting = async (profileApiUrl, userId, hadesPublicBase) => {
    const userToken = await getUserToken(hadesPublicBase);
    if (userToken) {
        const TRUST_TIMEOUT = 1000;
        const trustClient = new TrustClient(profileApiUrl, TRUST_TIMEOUT);
        try {
            const { status, trustProfileSettings } = await trustClient.getProfileTrustSettings(userId, userToken);
            if (status === HTTPStatusCode.OK) {
                return trustProfileSettings;
            }
        }
        catch (error) {
            console.error(
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            `error getting trust profile settings: [${error.status}, ${error.info}]`);
            return undefined;
        }
    }
};

const init = (presenceApiUrl, hadesPublicBase, userId, intervalTime) => {
    const DEFAULT_RETRY = 1000; // as milliseconds
    const settings = {
        apiUrl: presenceApiUrl,
        userId: `sdrn:subito:user:${userId}`,
        retry: {
            defaultTime: intervalTime || DEFAULT_RETRY,
        },
        getUserToken: () => getUserToken(hadesPublicBase),
    };
    presenceInput.init(settings);
};
/**
 * @param profileApiUrl - trust presence API url (https://profile-api.trust-pre.mpi-internal.com || https://profile-api.trust-pro.mpi-internal.com)
 * @param presenceApiUrl - trust presence API url (https://presence-api.trust-pre.mpi-internal.com || https://presence-api.trust-pro.mpi-internal.com)
 * @param hadesPublicBase - hade public base url
 * @param userId - user id
 * @param checkSetting - set to true when consumer does not know if presence feature is enabled/disabled
 * @param intervalTime - amount of milleseconds for the next ping
 */
const presencePing = async ({ presenceApiUrl, profileApiUrl, hadesPublicBase, userId, checkSetting, intervalTime, }) => {
    if (checkSetting) {
        const setting = await getSetting(profileApiUrl, userId, hadesPublicBase);
        if (setting?.enabled) {
            init(presenceApiUrl, hadesPublicBase, userId, intervalTime);
        }
    }
    else {
        init(presenceApiUrl, hadesPublicBase, userId, intervalTime);
    }
};

export { presencePing };
//# sourceMappingURL=index.js.map
